
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import TransactionsCore from './TransactionsCore'

// Make sure we have the training-app holder
// If this is missing, we're not on the appropriate page
if ($(document).find('#transactions-app').length > 0){
	ReactDOM.render(
		<TransactionsCore />,
		document.getElementById('transactions-app')
	);
}


// WEBPACK FOOTER //
// ./app/js/components/Transactions.js